import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResetPasswordComponent } from './reset-password.component';
import { InputModule } from 'src/app/common/utilities/input/input/input.module';
import { ButtonFillModule } from 'src/app/common/utilities/buttons/button-fill/button-fill/button-fill.module';
import { ErrorMessageModule } from "../../common/components/error-message/error-message.module";




@NgModule({
  declarations: [
    ResetPasswordComponent
  ],
  imports: [
    CommonModule,
    InputModule,
    ButtonFillModule,
    ErrorMessageModule,
  ]
})
export class ResetPasswordModule { }
